<template>
  <div class="h-100">
    <Header/>
    <div class="tab-content content-height" :class="isMobile ? 'suggestions-tab-content-mobile' : 'suggestions-tab-content'" id="myTabContent">
      <div class="tab-pane fade show active h-100" role="tabpanel" aria-labelledby="all-tab">
        <div class="card">
          <div class="card-body p-0">
            <div class="row w-100 m-0">
              <div class="col-12 tenders-list p-0">
                <div class="d-flex flex-column padding-10">
                  <SearchInput @handleSearch="handleSearch" />
                  <div class="d-flex flex-wrap gap-2">
                    <tender-card @click="$router.push(`/timeless-tenders/sell/tender/${tender.id}`)" :tender="tender" :selectedType="'seller'" :can-edit="false" v-for="tender in tenders" :key="tender.id"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import isMobile from '@/mixins/isMobileView'
  import Header from '../header.vue'
  import TenderCard from '@/components/timelessTenders/tenderCard.vue'
  import SearchInput from '@/components/timelessTenders/SearchInput.vue'

  export default {
    components: { SearchInput, TenderCard, Header },
    mixins: [isMobile],
    data() {
      return {
        dateNow: new Date(),
        backendUrl: process.env.VUE_APP_URL,
        tenders: [],
        searchQuery: '',
        columns: [
          'password',
          'title',
          'products',
          'opening_finish_date',
          'price',
          'region',
          'type',
          'invitation',
          'edit',
          'participants_count'
        ],
      }
    },
    computed: {
      currentPlan() {
        return this.$store.getters['procurement/currentPlan']
      },
      locale() {
        return this.$store.getters['user/locale']
      }
    },
    mounted() {
      this.getTenders();
    },
    methods: {
      handleSearch(query){
        this.searchQuery = query;
        this.getTenders();
      },
      getTenders() {
        this.$client.get('timeless-tenders', {
          params: {
            type: 'seller',
            favorite: true,
            query: this.searchQuery,
          }
        }).then(({ data }) => {
          console.log('data', data.data)
          this.tenders = data.data;
        })
      },
    },
  }
</script>
